'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OktaContext = require('./OktaContext');

var _OktaError = require('./OktaError');

var _OktaError2 = _interopRequireDefault(_OktaError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginCallback = function LoginCallback(_ref) {
  var errorComponent = _ref.errorComponent;

  var _useOktaAuth = (0, _OktaContext.useOktaAuth)(),
      authService = _useOktaAuth.authService,
      authState = _useOktaAuth.authState;

  var authStateReady = !authState.isPending;

  var ErrorReporter = errorComponent || _OktaError2.default;

  (0, _react.useEffect)(function () {
    if (authStateReady) {
      // wait until initial check is done so it doesn't wipe any error
      authService.handleAuthentication();
    }
  }, [authService, authStateReady]);

  if (authStateReady && authState.error) {
    return _react2.default.createElement(ErrorReporter, { error: authState.error });
  }

  return null;
}; /*
    * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
    * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
    *
    * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
    * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    *
    * See the License for the specific language governing permissions and limitations under the License.
    */

exports.default = LoginCallback;